<template>
  <main class="l-main p-register set">
    <div class="l-block">
      <SetLocalNav :hasProject="hasProject" />
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="mv-img">
        <img
          :src="require('@/assets/img/mv-register-register.png')"
          alt="本登録が完了しました！"
        />
      </div>
      <div class="l-block__content confirm">
        <div class="message">
          <div class="hTitle">
            <h1>
              <img src="@/assets/img/txt-thankyou.svg" alt="Thank you." />
            </h1>
          </div>
          <h2 class="h-minTitle">
            登録完了。データ連携をはじめます。
          </h2>
        </div>
        <div class="flex project">
          <div class="title">
            <p>サイト名</p>
          </div>
          <div class="form c-alertPos">
            {{ params.projectName }}
          </div>
        </div>
        <div class="flex project">
          <div class="title">
            <p>登録するURL</p>
          </div>
          <div class="form c-alertPos">
            {{ ga4DataStream.websiteUrl }}
          </div>
        </div>
        <h2 class="minTitle">連携するGoogle Analytics</h2>
        <div class="flex">
          <div class="title">
            <p>アカウント</p>
          </div>
          <div class="form c-alertPos">
            {{ ga4Account.name }}
            <Alert v-if="error.ga4AccountId">
              {{ error.ga4AccountId }}
            </Alert>
          </div>
        </div>

        <div class="flex">
          <div class="title">
            <p>プロパティ</p>
          </div>
          <div class="form c-alertPos">
            {{ ga4Property.name }}
            <Alert v-if="error.ga4PropertyId">
              {{ error.ga4PropertyId }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>データストリーム</p>
          </div>
          <div class="form c-alertPos">
            {{ ga4DataStream.name }}
            <Alert v-if="error.ga4DataStreamId">
              {{ error.ga4DataStreamId }}
            </Alert>
          </div>
        </div>

        <h2 class="minTitle">連携するGoogle Search Console</h2>
        <div class="flex">
          <div class="title">
            <p>プロパティ名</p>
          </div>
          <div class="form c-alertPos">
            {{ params.gscSiteUrl }}
            <Alert v-if="error.gscSiteUrl">
              {{ error.gscSiteUrl }}
            </Alert>
          </div>
        </div>
        <div class="btnArea">
          <div class="form-auto">
            <Button
              size="w260"
              variant="border"
              icon="return_gn"
              fsize="f16"
              :to="{ name: 'set' }"
            >
              内容を修正する
            </Button>
          </div>
          <div class="form-auto">
            <Button
              size="w260"
              variant="main"
              fsize="f16"
              icon="arrow_r"
              :class="{ 'is-loading': isProcessing }"
              :disabled="isError || isProcessing"
              @click="submit"
            >
              データ連携を開始
            </Button>
          </div>
        </div>
        <div v-if="errorResponse" class="l-mt-3">
          <Alert>{{ errorResponse }}</Alert>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Progress from '@/components/Progress';
import SetLocalNav from '@/components/set/SetLocalNav';
import TitleRegister from '@/components/TitleRegister';
import utils from '@/utils';
import Validation from '@/validation';
import apiProjects from '@/api/projects';

export default {
  props: ['hasProject'],

  components: {
    Alert,
    Button,
    Progress,
    SetLocalNav,
    TitleRegister
  },

  data() {
    return {
      data: Object.assign({}, this.$store.state.set.data),
      error: {
        ga4AccountId: '',
        ga4PropertyId: '',
        ga4DataStreamId: '',
        gscSiteUrl: '',
        projectName: ''
      },
      errorResponse: '',
      params: Object.assign({}, this.$store.state.set.params),
      isError: false,
      isProcessing: false,
      progress: [
        {
          label: 'Google Analyticsの登録'
        },
        {
          label: 'Google Search Consoleの登録'
        },
        {
          current: true,
          label: '確認'
        }
      ]
    };
  },

  computed: {
    agentCode() {
      return this.$store.state.user.status.agentCode;
    },
    ga4Account() {
      const data = { id: '', name: '' };
      const ga4Account = this.data.ga4Accounts.find(
        account => account.name === this.params.ga4AccountId
      );
      if (ga4Account) {
        data.id = ga4Account.name;
        data.name = ga4Account.displayName;
      }
      return data;
    },
    ga4Property() {
      const data = { id: '', name: '' };
      const ga4Property = this.data.ga4Properties.find(
        property => property.name === this.params.ga4PropertyId
      );
      if (ga4Property) {
        data.id = ga4Property.name;
        data.name = ga4Property.displayName;
      }
      return data;
    },
    ga4DataStream() {
      const data = { id: '', name: '', websiteUrl: '' };
      const ga4DataStream = this.data.ga4DataStreams.find(
        dataStream => dataStream.name === this.params.ga4DataStreamId
      );
      if (ga4DataStream) {
        data.id = ga4DataStream.name;
        data.name = ga4DataStream.displayName;
        data.websiteUrl = ga4DataStream.webStreamData.defaultUri;
      }
      return data;
    },
    organization() {
      return this.$store.getters['view/organization'];
    }
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    }
  },

  created() {
    this.validation();

    for (let key in this.error) {
      if (this.error[key]) {
        this.$router.push({ name: 'set' });
        break;
      }
    }
  },

  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },

    submit() {
      if (this.isError || this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      // サーバーサイドにサイト情報を送る
      this.postProject()
        .then(() => {
          // 一時データを削除
          this.$store.dispatch('set/reset');

          // サイト一覧を取得し直す
          this.$store.dispatch('user/getProjects').finally(() => {
            // Auth0に一時的に保存したサイト情報を削除する
            this.auth
              .getUserData()
              .then(response => {
                let metaData = response.data.user_metadata;
                // tmpKeyが一致するサイトを削除する
                metaData.projects = metaData.projects.filter(item => {
                  if (item.tmpKey !== this.params.tmpKey) {
                    return true;
                  }
                });
                let data = {
                  user_metadata: metaData
                };
                this.auth.updateUserData(data).finally(() => {
                  this.goProjects();
                });
              })
              .catch(error => {
                this.goProjects();
              });
          });
        })
        .catch(error => {
          if (error.response) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    },

    goProjects() {
      this.$router.push({ name: 'projects' });
    },

    postProject() {
      const params = {
        ga4AccountId: this.params.ga4AccountId,
        ga4PropertyId: this.params.ga4PropertyId,
        ga4DataStreamId: this.params.ga4DataStreamId,
        gscSiteUrl: this.params.gscSiteUrl,
        organizationId: this.organization.organizationId,
        projectName: this.params.projectName,
        tmpKey: this.params.tmpKey
      };
      return apiProjects.post(params, this.auth.idToken);
    },

    validation() {
      this.error.ga4AccountId = new Validation()
        .select()
        .test(this.params.ga4AccountId);
      this.error.ga4PropertyId = new Validation()
        .select()
        .test(this.params.ga4PropertyId);
      this.error.ga4DataStreamId = new Validation()
        .select()
        .test(this.params.ga4DataStreamId);

      if (utils.isScDomain(this.params.gscSiteUrl)) {
        this.error.gscSiteUrl =
          'ドメインプロパティには対応しておりません。URLプレフィックスプロパティに変更してください';
      } else {
        this.error.gscSiteUrl = new Validation()
          .select()
          .test(this.params.gscSiteUrl);
      }

      this.error.projectName = new Validation()
        .input()
        .test(this.params.projectName);
    }
  }
};
</script>
